module.exports = __webpack_public_path__ + "static/partnership_img6@2x-8923ee5b577bac39a36e5227f5a2919a.jpg";